import React, { useEffect, useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import {  message, Upload } from 'antd';
import { itemsService } from '../../../services/items.service';
import {  GetItemImageToEdit, SetItemImageToEdit } from '../../../store/itemAtom';
import { BASE_WIDTH, BASE_HEIGHT } from '../../../helpers/constantsFile';



const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return;

    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
      return ;
    }
    return isJpgOrPng && isLt2M;
  };



function PrimaryImageUpload(props) {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const [currentImageId, setCurrentImageId] = useState(props?.imageId);
  const getItemImageToEdit = GetItemImageToEdit();
  const setItemImageToEdit = SetItemImageToEdit();

  useEffect(()=> {
    if(props?.defaultImage){
      setImageUrl(props.defaultImage);
    }
  },[props?.defaultImage]);

  useEffect(() => {
    setCurrentImageId(props?.imageId);
  }, [props?.imageId]);



  const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
  
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
  
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
  
        img.onerror = reject;
      };
  
      reader.onerror = reject;
    });
  };
  

    
    const customUpload = async ({ file, onSuccess, onError }) => {
      const valid = beforeUpload(file);
      if (!valid) return;

      if (!props?.Item_Id) {
        message.error('Item ID is missing. Please save item information first.');
        return;
      }

      getImageDimensions(file).then((dim) => {
        // Priority 3: fix && → || so either wrong dimension rejects the image
        if (dim?.height !== BASE_HEIGHT || dim.width !== BASE_WIDTH) {
          message.error(`REJECTED! The image dimension should be ${BASE_HEIGHT}H and ${BASE_WIDTH}W`);
          return;
        }

        message.info('Uploading image...');
        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);
        const activeImageId = currentImageId || props?.imageId;
        const formObject = {
          Item_Id: props?.Item_Id,
          image_id: activeImageId || 0,
          option: activeImageId ? 4 : 1,
        };
        formData.append('formObject', JSON.stringify(formObject));

        itemsService.submitItemImage(formData).then(res => {
          onSuccess(res.data);
          const newUrl = res.data?.file_link;
          const returnedImageId = res.data?.image_id || activeImageId;
          if (returnedImageId) {
            setCurrentImageId(returnedImageId);
          }
          message.success('Upload successful');
          setImageUrl(newUrl);
          setLoading(false);

          try {
            const currentList = Array.isArray(getItemImageToEdit) ? [...getItemImageToEdit] : [];
            let updated = false;

            if (typeof props?.index === 'number') {
              while (currentList.length <= props.index) {
                currentList.push({});
              }
              currentList[props.index] = {
                ...currentList[props.index],
                image_id: returnedImageId || currentList[props.index]?.image_id,
                image_url: newUrl,
              };
              updated = true;
            } else if (activeImageId) {
              const idx = currentList.findIndex(img => img?.image_id === activeImageId);
              if (idx !== -1) {
                currentList[idx] = {
                  ...currentList[idx],
                  image_url: newUrl,
                };
                updated = true;
              }
            }

            if (!updated && newUrl) {
              currentList.push({
                image_id: returnedImageId,
                image_url: newUrl,
              });
            }

            setItemImageToEdit(currentList);
          } catch (stateErr) {
            console.error('Error updating image state:', stateErr);
          }
        }).catch(err => {
          onError(err);
          setLoading(false);
          message.error('Image upload failed!');
        });
      }).catch((err) => {
        console.log('dim_error ', err);
        setLoading(false);
        onError(err);
        message.error('Failed to load image for validation');
      });
    };


  const uploadButton = (
    <button  style={{  border: 0,  background: 'none'  }}type="button" >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{  marginTop: 8,  }}  >
        Upload
      </div>
    </button>
  );

    return ( 
        <>
           <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
       
        // onChange={onFileChange}
        // beforeUpload={beforeUpload}
        customRequest={customUpload}  // Use manual upload
        multiple={false}
      >
        {imageUrl ? (
          <>
          <img   src={imageUrl}  alt="avatar"   style={{   width: '100%',  }}  />
         
          </>
          
        ) : (    uploadButton  )}
      </Upload>

      
        </>
     );
}

export default PrimaryImageUpload;